import { useQuery } from "@tanstack/react-query";
import { getTargetareListaPropuneri } from "@/api/endpoints/targetareConfig";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareListaPropuneri(activ = true) {
  return useQuery({
    queryKey: queryKeys.targetare.listaPropuneri(),
    queryFn: getTargetareListaPropuneri,
    select: (response) => response.data,
    enabled: activ,
    staleTime: 1000 * 60,
    retry: 1,
  });
}
